import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import { useAppContext } from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";
import { BetterTabs } from "@examspark/common-ui/dist/components/tabs/Tabs";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import Copyright from "../../components/common/Copyright";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import { WorkspaceAssessments } from "../../components/workspace/WorkspaceAssessments";
import WorkspaceCalendar from "../../components/workspace/WorkspaceCalendar";
import WorkspaceOverview from "../../components/workspace/WorkspaceOverview";
import WorkspaceUsers from "../../components/workspace/WorkspaceUsers";

const Footer = styled.footer`
  border-top: solid 1px ${colorFromTheme("surface5")};
  font-size: var(--font-size-xsmall);
  line-height: 1.5em;
  padding-top: 1rem;
  margin-top: 2rem;
  margin-bottom: 4rem;
  color: ${colorFromTheme("secondary", "textColor")};
  grid-area: footer;
`;

const WorkspaceRoute = () => {
  const params = useParams<{
    tab: string;
  }>();
  const navigate = useNavigate();
  const [context] = useAppContext();

  return (
    <VSpace size="3rem">
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle>{context.workspaceUser?.workspace?.name}</PageTitle>
      </PageHead>
      <BetterTabs
        activeTab={params.tab}
        tabs={[
          { tab: undefined, label: "Overview", element: <WorkspaceOverview /> },
          {
            tab: "exams",
            label: "Assessments",
            element: <WorkspaceAssessments />,
          },
          {
            tab: "calendars",
            label: "Calendar",
            element: <WorkspaceCalendar />,
          },
          { tab: "people", label: "People", element: <WorkspaceUsers /> },
        ]}
        onTabChange={(value) => {
          navigate(value == null ? "/workspace" : `/workspace/${value}`);
        }}
      />
      <Footer>
        <Copyright />
      </Footer>
    </VSpace>
  );
};

export default WorkspaceRoute;
